import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Header } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  title: string;
};

const styles = {
  header: {
    paddingLeft: '1rem !important',
    color: '#646464 !important',
    fontSize: '.875rem !important',
  },
};

const Gender: FunctionComponent<Props> = ({ classes, title }) => (
  <Header className={classes.header} as="h4">
    {title}
  </Header>
);

export default withStyles(styles)(Gender);
